const editions = {
  ['2024']: {
    dates: [
      [new Date(2025, 4, 13), 8, 18],
      [new Date(2025, 4, 14), 8, 18],
      [new Date(2025, 4, 15), 8, 18],
      [new Date(2025, 4, 16), 8, 18],
      [new Date(2025, 4, 17), 8, 12],
    ],
    formId: 1057,
    formQuestions: {
      firstName: 7003,
      lastName: 7005,
      email: 7007,
      phone: 7009,
      birthdate: 7011,
      consent: 7017,
      date: 7013,
      duration: 7015,
    },
    stopwatchId: 1,
    enableSeconds: true,
    minutesSafeZone: 30,
    hunter: '',
    target: '',
    localStorageKey: 'Wanted',
  },
  ['2025']: {
    dates: [
      [new Date(2025, 4, 19), 8, 18],
      [new Date(2025, 4, 20), 8, 18],
      [new Date(2025, 4, 21), 8, 18],
      [new Date(2025, 4, 22), 8, 18],
      [new Date(2025, 4, 23), 8, 12],
    ],
    formId: 1179,
    formQuestions: {
      firstName: 8148,
      lastName: 8151,
      email: 8154,
      phone: 8157,
      birthdate: 8160,
      consent: 8169,
      date: 8163,
      duration: 8166,
    },
    stopwatchId: 7,
    enableSeconds: false,
    minutesSafeZone: 3 * 60,
    hunter: '',
    target: '',
    localStorageKey: 'wanted-2025',
  },
}

export const AIRBRAKE_PROJECT_ID = 560178
export const AIRBRAKE_PROJECT_KEY = '3e3d8675f0b0010546da1b3587d7252f'

const edition = editions['2025']

export const DATES = edition.dates
export const FORM_ID = edition.formId
export const QUESTION_DATE_ID = edition.formQuestions.date
export const QUESTION_DURATION_STRING_ID = edition.formQuestions.duration
export const FORM_QUESTIONS = edition.formQuestions
export const STOPWATCH_ID = edition.stopwatchId

// Amount of time before a vote can be cast, so a user can not vote
// vor something in the next MINUTES_SAFE_ZONE
export const MINUTES_SAFE_ZONE = edition.minutesSafeZone

// Should users be able to vote on seconds
export const ENABLE_SECONDS = edition.enableSeconds
export const LOCAL_STORAGE_KEY = edition.localStorageKey
